"use client"

import { BadgeQuestionMark } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BadgeQuestionMarkIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BadgeQuestionMarkIcon = component(Icon)({ as: BadgeQuestionMark })
